(function () {
  'use strict';

  function initialiseFacets(root) {
    var form = root.querySelector('.tcc-facets__form');
    var toggle = root.querySelector('.tcc-facets__mobile-toggle');
    var sort = root.querySelector('[data-tcc-sort]');
    var details = Array.prototype.slice.call(root.querySelectorAll('.tcc-facet'));

    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var open = form.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (sort && form) sort.addEventListener('change', function () { form.submit(); });

    details.forEach(function (facet) {
      facet.addEventListener('toggle', function () {
        if (!facet.open || window.innerWidth < 1024) return;
        details.forEach(function (other) {
          if (other !== facet) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (window.innerWidth < 1024 || root.contains(event.target)) return;
      details.forEach(function (facet) { facet.removeAttribute('open'); });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-tcc-facets]').forEach(function (root) {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      initialiseFacets(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
